module.exports = __webpack_public_path__ + "static/media/BoldBlack.27463012.svg";